export function walletIdentityAfterSessionClear(
  connectedWallet: string | undefined,
  explicitLogout: boolean,
): string | undefined {
  return explicitLogout ? undefined : connectedWallet;
}
